import type { TableRowDefinition } from "$components/table";
import { parseISO } from "date-fns";
import { format, utcToZonedTime } from "date-fns-tz";
import type { IntlShape } from "react-intl";
import type { NigeriaGeneralAttendanceRegisterRecord } from "../../../../__generated__/base.gql";
import { CellWithSubscript } from "../../_lib/cell-with-subscript";
import { getAge } from "../../_lib/get-age";

export function createRowFormatter(
  timeZone: string,
  formatMessage: IntlShape["formatMessage"],
) {
  return (
    record: NigeriaGeneralAttendanceRegisterRecord,
  ): TableRowDefinition => {
    const date = utcToZonedTime(parseISO(record.date), timeZone);
    const dob = utcToZonedTime(parseISO(record.patient.dateOfBirth), timeZone);

    return {
      id: record.id,
      patientUuid: record.patient.patientUuid,
      createdAt: CellWithSubscript({
        script: format(date, "dd MMM", { timeZone }),
        subscript: format(date, "yyyy", { timeZone }),
      }),
      name: record.patient.name ?? "-",
      cardNumber: record.patient.cardId ?? "-",
      dob: record.patient.dateOfBirth
        ? CellWithSubscript({
            script: format(dob, "dd MMM", { timeZone }),
            subscript: format(dob, "yyyy", { timeZone }),
          })
        : "-",
      gender: record.patient.gender?.toUpperCase() ?? "-",
      age: getAge({ dateOfBirth: dob, date }, formatMessage) ?? "-",
      address:
        record.patient.address?.street ||
        record.patient.address?.ward ||
        record.patient.address?.subCounty ? (
          <div style={{ flexDirection: "column", maxWidth: "150px" }}>
            {record.patient.address?.street && (
              <div>{record.patient.address?.street}</div>
            )}
            {record.patient.address?.ward && (
              <div>{record.patient.address?.ward}</div>
            )}
            {record.patient.address?.subCounty && (
              <div>{record.patient.address?.subCounty}</div>
            )}
          </div>
        ) : (
          "-"
        ),
      state: record.patient.address?.state ?? "-",
      phoneNumber: record.patient.phoneNumber?.value ?? "-",
      firstContact: record.patient.firstContact ? "Yes" : "No",
      nextOfKinName: record.patient.nextOfKinName ?? "-",
      nextOfKinAddress:
        record.patient.nextOfKinAddress?.street ||
        record.patient.nextOfKinAddress?.ward ||
        record.patient.nextOfKinAddress?.subCounty ||
        record.patient.nextOfKinAddress?.state ? (
          <div style={{ flexDirection: "column", maxWidth: "150px" }}>
            {record.patient.nextOfKinAddress?.street && (
              <div>{record.patient.nextOfKinAddress?.street}</div>
            )}
            {record.patient.nextOfKinAddress?.ward && (
              <div>{record.patient.nextOfKinAddress?.ward}</div>
            )}
            {record.patient.nextOfKinAddress?.subCounty && (
              <div>{record.patient.nextOfKinAddress?.subCounty}</div>
            )}
            {record.patient.nextOfKinAddress?.state && (
              <div>{record.patient.nextOfKinAddress?.state}</div>
            )}
          </div>
        ) : (
          "-"
        ),
      nextOfKinRelationship: (
        <span style={{ textTransform: "capitalize" }}>
          {record.patient.nextOfKinRelationship ?? "-"}
        </span>
      ),
      nextOfKinPhoneNumber: record.patient.nextOfKinPhoneNumber ?? "-",
    };
  };
}
